import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createRef, Component } from 'react';
import { propArrayShape, propChildren, propNumber, propOneOfType, propShape, propStrList, } from '../../../../helpers/custom-prop-types';
import CustomSlider from '../../Slider';
import PdfImageModalThumbnailSliderBottomItem from './PdfImageModalThumbnailSliderBottomItem';
import PdfImageModalThumbnailSliderTopItem from './PdfImageModalThumbnailSliderTopItem';
const slidesToShow = 7;
class PdfImageModalThumbnailSlider extends Component {
    constructor(props) {
        super(props);
        this.changeSliderMain = (current, next) => {
            this.navRef.current.slickGoTo(next);
        };
        this.changeSlideNav = (current, next) => {
            this.slideRef.current.slickGoTo(next);
        };
        this.setSlideRef = (ref) => {
            this.slideRef.current = ref;
        };
        this.setNavRef = (ref) => {
            this.navRef.current = ref;
        };
        this.getState = (props) => {
            const { images, pdfProp } = props;
            const bottomFillCount = Math.max(0, slidesToShow - images.length);
            const topConfig = this.getTopSliderConfig(props);
            const bottomConfig = this.getBottomSliderConfig(props);
            const { isObject, key } = pdfProp;
            return {
                bottomConfig,
                bottomFillCount,
                images: images.map((url, index) => {
                    if (isObject && key) {
                        return {
                            index: url.id,
                            item: {
                                item: url,
                                pdfProp,
                            },
                            url: url[key],
                        };
                    }
                    return {
                        index,
                        item: {
                            item: url,
                            pdfProp,
                        },
                        pdfProp,
                        url,
                    };
                }),
                topConfig,
            };
        };
        this.getTopSliderConfig = (props) => {
            const { initialSlide } = props;
            return {
                arrows: true,
                beforeChange: this.changeSliderMain,
                centerMode: true,
                centerPadding: 0,
                className: 'slider-main',
                draggable: false,
                fade: true,
                infinite: true,
                initialSlide,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            centerPadding: 0,
                            dots: true,
                            draggable: true,
                            infinite: true,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            centerPadding: 0,
                            dots: true,
                            draggable: true,
                            infinite: true,
                        },
                    },
                ],
                rows: 1,
                slidesToShow: 1,
                waitForAnimate: false,
            };
        };
        this.getBottomSliderConfig = (props) => {
            const { initialSlide } = props;
            return {
                arrows: false,
                beforeChange: this.changeSlideNav,
                dots: false,
                draggable: true,
                focusOnSelect: true,
                infinite: true,
                initialSlide,
                rows: 1,
                slidesToShow,
                swipeToSlide: true,
            };
        };
        this.slideRef = createRef();
        this.navRef = createRef();
        this.state = this.getState(props);
    }
    shouldComponentUpdate(nextProps) {
        const { images, initialSlide, pdfProp } = this.props;
        if (initialSlide !== nextProps.initialSlide ||
            images !== nextProps.images ||
            pdfProp !== nextProps.pdfProp) {
            this.setState(this.getState(nextProps));
            return false;
        }
        return true;
    }
    render() {
        const { customChildren, dataAttributes } = this.props;
        const { bottomConfig, bottomFillCount, images, topConfig } = this.state;
        return (_jsxs("div", Object.assign({ className: 'l-slide slide-container initialized' }, { children: [_jsx(CustomSlider, Object.assign({ className: 'slider-main solution-main-slider', config: topConfig, dataAttributes: dataAttributes, setSliderRef: this.setSlideRef }, { children: images.map(({ index, item, url }) => (_jsx(PdfImageModalThumbnailSliderTopItem, { customChildren: customChildren, item: item, url: url }, index))) })), _jsx(CustomSlider, Object.assign({ className: 'slider-nav', config: bottomConfig, dataAttributes: dataAttributes, fillCount: bottomFillCount, setSliderRef: this.setNavRef, wrapperClassName: 'slide-nav-container initialized', wrapperElement: 'div' }, { children: images.map(({ index, url }) => (_jsx(PdfImageModalThumbnailSliderBottomItem, { dataAttributes: dataAttributes, url: url }, index))) }))] })));
    }
}
PdfImageModalThumbnailSlider.propTypes = {
    customChildren: propChildren(),
    dataAttributes: propShape().isRequired,
    images: propOneOfType([propStrList(), propArrayShape()]).isRequired,
    initialSlide: propNumber().isRequired,
    pdfProp: propShape().isRequired,
};
PdfImageModalThumbnailSlider.defaultProps = {
    customChildren: undefined,
};
export default PdfImageModalThumbnailSlider;
